import {Reducer} from "redux";
import * as Routines from "../routines";
import { NotificationEventsState } from "@Safemate/map/Store/types";

const notificationEvent: Reducer<NotificationEventsState> = (state: NotificationEventsState = {}, action) => {
  switch (action.type) {
    case Routines.getNotificationEvents.SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload.events
      };


    default:
      return state;
  }
};

export default notificationEvent;
